import React from "react";

export default function CartZero() {
  return (
    <div className="cart-none">
      <h2>Shopping Basket</h2>
      <h3>Your basket is currently empty.</h3>
    </div>
  );
}
